import { GridItem, Spacer, Text, useDisclosure } from "@chakra-ui/react";
import { ReactNode } from "react";

import { RanaButton, RanaModal, RightArrowIcon } from "@nens/ranalib";

import { ContentPanel } from "@/components/content-panel";
import { cancelButtonText } from "@/translations";

interface LibraryCardProps {
  title: string;
  description: ReactNode;
  buttonLabel: ReactNode;
  modalTitle: string;
  height: number | string;
  children: ReactNode;
}

export function LibraryCard({
  title,
  description,
  buttonLabel,
  modalTitle,
  height,
  children,
}: LibraryCardProps) {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <GridItem
        h={height}
        cursor="pointer"
        _hover={{ "& > *": { bg: "button.tertiary.hover" } }}
        onClick={onOpen}
      >
        <ContentPanel display="flex" flexDir="column" justifyContent="space-between" title={title}>
          <Text>{description}</Text>
          <Spacer />
          <RanaButton w="fit" ml="auto" variant="tertiary">
            {buttonLabel}
            <RightArrowIcon ml={2} />
          </RanaButton>
        </ContentPanel>
      </GridItem>
      {/* Outside GridItem so modal clicks do not bubble to onOpen */}
      <RanaModal
        isOpen={isOpen}
        onClose={onClose}
        topBar={modalTitle}
        maxW="5xl"
        buttons={[{ children: cancelButtonText, variant: "tertiary", onClick: () => onClose() }]}
      >
        {children}
      </RanaModal>
    </>
  );
}
